"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["onSubmit"];
const _hoisted_2 = { class: "flex flex-col md:flex-row" };
const _hoisted_3 = {
    type: "submit",
    class: "button button-outlined button-mutedpurple-800 hover:button-mutedpurple-700 rounded-t-none rounded-3xl md:rounded-full md:rounded-l-none h-12 my-0 md:border-l-0 has-icon flex-shrink-0"
};
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "flex-auto" }, "Sign Up", -1);
const ButtonIcon_vue_1 = __importDefault(require("./ButtonIcon.vue"));
const Forms_1 = __importDefault(require("../src/api/Forms"));
const vue_3 = require("vue");
const Alerts_1 = require("../stores/Alerts");
const AlertType_1 = require("../src/types/AlertType");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NewsletterForm',
    setup(__props) {
        const alertStore = (0, Alerts_1.useAlertsStore)();
        const email = (0, vue_3.ref)('');
        function onSubmit() {
            let form = {
                type: 'newsletter',
                email: email.value,
            };
            Forms_1.default.submit(form).then((response) => {
                alertStore.add({
                    type: AlertType_1.AlertType.Success,
                    message: "Thanks for signing up!",
                    key: 'newsletter'
                });
            }).catch((err) => {
                var _a, _b;
                let message = 'There was a problem signing up to the newsletter.';
                if ((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) {
                    message = err.response.data.error;
                }
                alertStore.add({
                    type: AlertType_1.AlertType.Error,
                    message: message,
                    key: 'newsletter',
                });
            });
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("form", {
                action: "#",
                onSubmit: (0, vue_2.withModifiers)(onSubmit, ["prevent"])
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                        type: "email",
                        name: "email",
                        class: "input rounded-3xl rounded-b-none md:rounded-full md:rounded-r-none border-b-0 md:border-b-2 flex-auto h-12 min-h-[3.125rem] w-full md:w-16",
                        placeholder: "Email address...",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event))
                    }, null, 512), [
                        [vue_2.vModelText, email.value]
                    ]),
                    (0, vue_2.createElementVNode)("button", _hoisted_3, [
                        (0, vue_2.createVNode)(ButtonIcon_vue_1.default, { class: "flex-grow-0" }),
                        _hoisted_4
                    ])
                ])
            ], 40, _hoisted_1));
        };
    }
});
